import PropTypes from 'prop-types';

function Icons({ type }) {
    let icon;

    switch(type) {
        case 'play':
            icon = <IconPlay />;
            break;
        case 'pause':
            icon = <IconPause />;
            break;
        default:
            icon = <IconPlay />;
    }

    return icon;
}

Icons.propTypes = {
  type: PropTypes.string.isRequired
}

export default Icons;

const IconPlay = () => {
    return (
        <svg role="img" className="svg--play" xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
            <title>reprendre la lecture de la vidéo</title>
            <g data-name="Play" transform="translate(12) rotate(90)" >
                <path d="M 14.13147926330566 11.50000095367432 L 1.86851954460144 11.50000095367432 C 1.598189473152161 11.50000095367432 1.470169544219971 11.31533145904541 1.427679538726807 11.23593139648438 C 1.385189533233643 11.15653133392334 1.302539467811584 10.94757175445557 1.452489495277405 10.72265148162842 L 7.583979606628418 1.525421380996704 C 7.678309440612793 1.383921384811401 7.829939365386963 1.302771329879761 7.999999523162842 1.302771329879761 C 8.170059204101562 1.302771329879761 8.321689605712891 1.383921384811401 8.416019439697266 1.525421380996704 L 14.54749965667725 10.72265148162842 C 14.69745922088623 10.94757175445557 14.6148099899292 11.15653133392334 14.57231998443604 11.23593139648438 C 14.52982997894287 11.31533145904541 14.40180969238281 11.50000095367432 14.13147926330566 11.50000095367432 Z" />
                <path d="M 7.9998779296875 1.802953720092773 L 7.999999523162842 1.80277156829834 L 1.86851978302002 11.00000095367432 L 14.13147830963135 11.00000095367432 C 14.13147830963135 11.00000095367432 14.13147830963135 11.00000095367432 14.13147926330566 11.00000095367432 L 7.9998779296875 1.802953720092773 M 7.999999523162842 0.8027734756469727 C 8.317070007324219 0.8027734756469727 8.634140014648438 0.9512062072753906 8.832049369812012 1.248071670532227 L 14.96352958679199 10.4453010559082 C 15.406569480896 11.1098518371582 14.93017959594727 12.00000095367432 14.13147926330566 12.00000095367432 L 1.86851978302002 12.00000095367432 C 1.069819450378418 12.00000095367432 0.5934295654296875 11.1098518371582 1.036469459533691 10.4453010559082 L 7.167949676513672 1.248071670532227 C 7.365859985351562 0.9512062072753906 7.682929992675781 0.8027734756469727 7.999999523162842 0.8027734756469727 Z" />
            </g>
        </svg>
    )
}

const IconPause = () => {
    return (
        <svg role="img" className="svg--pause" xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12">
            <title>mettre en pause la vidéo</title>
            <g data-name="Pause button">
                <rect width="4" height="12" />
                <rect width="4" height="12" transform="translate(7, 0)" />
            </g>
        </svg>
    )
}
